import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { AllowedPaymentMethodModel } from '../../../Models/Models/Pension/Payments/AllowedPaymentMethodModel';
import { PaymentSubType } from '../../../Constants/Enums/Pension/Payments/PaymentSubType';

declare var IS_RUNNING_IN_APP_POOL;

export class AllowedPaymentMethodsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, paymentSubType: PaymentSubType, paymentAmount: number): Promise<Array<AllowedPaymentMethodModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Pension/Payments/AllowedPaymentMethods/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, paymentSubType: paymentSubType, paymentAmount: paymentAmount }

    return AjaxWrapper.get<Array<AllowedPaymentMethodModel>, any>(url, data);
  }
}

